import {
  Checkbox,
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Space,
  Spin,
} from "antd";
import Link from "antd/es/typography/Link";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import InputAddress from "react-thailand-address-autocomplete";
import { CancelButton } from "../../components/button/CancelButton";
import { GreenButton } from "../../components/button/GreenButton";
import { GuestLayout } from "../../components/layout/guest-layout";
import thJson from "../../jsondata/thailand_address.json";
import "./register.css";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
});

export const POST = async (path, data, header) => {
  const config = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
  };
  try {
    const response = await instance.post(
      `/${path}`,
      data,
      header ? header : config
    );
    console.log(config);
    data = await response.data;
    return data;
  } catch (error) {
    throw error.response;
  }
};

export default function Register() {
  const { phone_cust } = useParams();
  useEffect(() => {
    // test();
    thaiprovince();
    if (Cookies.get("phone") != phone_cust) {
      console.log(Cookies.get("phone"));
      Cookies.remove("jwt");
      Cookies.remove("phone");
      window.location = "/register-warranty/login";
    }
  }, []);

  const handleSubmit = async (e) => {
    console.log(formValue);
    if (pdpa === false) {
      message.open({
        type: "warning",
        content: "ยินยอมให้เก็บข้อมูลหรือไม่",
        style: {
          marginTop: "8vh",
          fontSize: "16px",
        },
      });
    } else {
      try {
        const register = await POST("warranty/register/", formValue);
        if (register) {
          window.location = `/register-warranty/order_list/${phone_cust}`;
        }
      } catch (error) {
        console.error(error);
      }
    }

    // await axios.post('http://localhost:8080/warranty/register/', formValue)
    //   .then(response => {
    // message.open({
    //   type: 'success',
    //   content: 'บันทึกสำเร็จ',
    //   style: {
    //     marginTop: '8vh',
    //     fontSize: '16px'
    //   },
    // });
    //     console.log(response);
    //   }).catch((error) => {
    //     console.log(error);
    //   });
  };

  const [pdpa, setpdpa] = useState(true);
  const [email, setemailcheck] = useState(true);
  const current = new Date();
  const date = `${current.getDate()}/${
    current.getMonth() + 1
  }/${current.getFullYear()}`;

  const [formValue, setformValue] = useState({
    prefix: "",
    firstname: "",
    lastname: "",
    fullname: "",
    address: "",
    cust_sub_district: "",
    district: "",
    city: "",
    Postcode: "",
    cust_email: "",
    consent_pdpa: "1",
    email: "",
    sms: "",
    cust_phone_number: phone_cust,
  });

  const [thisstate, setthisState] = useState({
    subdistrict: "",
    district: "",
    province: "",
    zipcode: "",
  });

  const onChange = (e) => {
    setthisState({
      [e.target.name]: e.target.value,
    });
  };

  const onSelect = (fullAddress) => {
    const { subdistrict, district, province, zipcode } = fullAddress;
    setthisState({
      subdistrict: subdistrict,
      district: district,
      province: province,
      zipcode: zipcode,
    });
  };

  const datainputChange = (e) => {
    setformValue({
      ...formValue,
      [e.target.name]: e.target.value,
    });
  };
  const datainputselect = (e) => {
    setformValue({
      ...formValue,
      prefix: e,
    });
    // alert(e.target.name);
  };

  const firstsubmitfn = () => {
    setfirstsubmit(true);
    setformValue({
      ...formValue,
      fullname: formValue.firstname + " " + formValue.lastname,
    });
  };

  const [firstsubmit, setfirstsubmit] = useState(false);
  const [disableinput, setdisableinput] = useState(false);
  const [inputshow, setinputshow] = useState(false);
  const [disablebutton, setdisablebutton] = useState(true);

  useEffect(() => {
    if (firstsubmit === true) {
      if (formValue.prefix === "") {
        message.open({
          type: "error",
          content: "กรุณากรอกคำนำหน้าชื่อ",
          style: {
            marginTop: "8vh",
            fontSize: "16px",
          },
        });
        setfirstsubmit(false);
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      } else if (formValue.firstname === "") {
        message.open({
          type: "error",
          content: "กรุณากรอกชื่อจริง",
          style: {
            marginTop: "8vh",
            fontSize: "16px",
          },
        });
        setfirstsubmit(false);
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      } else if (formValue.lastname === "") {
        message.open({
          type: "error",
          content: "กรุณากรอกนามสกุล",
          style: {
            marginTop: "8vh",
            fontSize: "16px",
          },
        });
        setfirstsubmit(false);
        window.scrollTo({ top: 50, left: 0, behavior: "smooth" });
      } else if (formValue.address === "") {
        message.open({
          type: "error",
          content: "กรุณากรอกรายระเอียดที่อยู่",
          style: {
            marginTop: "8vh",
            fontSize: "16px",
          },
        });
        setfirstsubmit(false);
        window.scrollTo({ top: 100, left: 0, behavior: "smooth" });
      } else if (formValue.city === "") {
        message.open({
          type: "error",
          content: "กรุณากรอกจังหวัด",
          style: {
            marginTop: "8vh",
            fontSize: "16px",
          },
        });
        setfirstsubmit(false);
        window.scrollTo({ top: 400, left: 0, behavior: "smooth" });
      } else if (formValue.district === "") {
        message.open({
          type: "error",
          content: "กรุณากรอกอำเภอ/เขต",
          style: {
            marginTop: "8vh",
            fontSize: "16px",
          },
        });
        setfirstsubmit(false);
        window.scrollTo({ top: 300, left: 0, behavior: "smooth" });
      } else if (formValue.cust_sub_district === "") {
        message.open({
          type: "error",
          content: "กรุณากรอกตำบล/แขวง",
          style: {
            marginTop: "8vh",
            fontSize: "16px",
          },
        });
        setfirstsubmit(false);
        window.scrollTo({ top: 200, left: 0, behavior: "smooth" });
      } else if (formValue.Postcode === "") {
        message.open({
          type: "error",
          content: "กรุณากรอกรหัสไปรษณีย์",
          style: {
            marginTop: "8vh",
            fontSize: "16px",
          },
        });
        setfirstsubmit(false);
        window.scrollTo({ top: 500, left: 0, behavior: "smooth" });
      } else if (formValue.cust_email === "") {
        message.open({
          type: "error",
          content: "กรุณากรอกอีเมล",
          style: {
            marginTop: "8vh",
            fontSize: "16px",
          },
        });
        setfirstsubmit(false);
        window.scrollTo({ top: 600, left: 0, behavior: "smooth" });
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValue.cust_email)) {
        message.open({
          type: "error",
          content: "รูปแบบอีเมลไม่ถูกต้อง",
          style: {
            marginTop: "8vh",
            fontSize: "16px",
          },
        });
        setfirstsubmit(false);
        window.scrollTo({ top: 600, left: 0, behavior: "smooth" });
      } else {
        message.open({
          type: "warning",
          content: "กรุณาตรวจสอบข้อมูลก่อนบันทึก",
          style: {
            marginTop: "8vh",
            fontSize: "16px",
          },
        });
        setdisableinput(true);
        setdisablebutton(false);
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }
    }
  }, [firstsubmit]);

  const disables = () => {
    setdisableinput(false);
    setdisablebutton(true);
    setfirstsubmit(false);
  };

  useEffect(() => {
    if (pdpa === true) {
      setformValue({
        ...formValue,
        pdpa: "1",
      });
    } else {
      setformValue({
        ...formValue,
        pdpa: "0",
      });
    }
  }, [pdpa]);

  useEffect(() => {
    if (email) {
      setformValue({
        ...formValue,
        email: "1",
        sms: 1,
      });
    } else {
      setformValue({
        ...formValue,
        email: "0",
        sms: 0,
      });
    }
  }, [email]);

  const thj = thJson;
  const [province, setProvince] = useState("");
  const [tambons, setTambons] = useState("");
  const [provincethai, setProvincethai] = useState([]);
  const [DistrictThai, setDistrictThai] = useState([]);
  const [district, setdistricts] = useState("");
  const [TambonThai, setTambonThai] = useState([]);
  const [zipcodes, setzipcodes] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    if (province) {
      const dup = thj.map(({ TambonID, ...rest }) => rest);
      const t = dup.filter((row) => row.ProvinceThai === province);

      let previousValue = null;
      const mappedJson = t.map((item) => {
        if (item.DistrictThaiShort === previousValue) {
          return null;
        }
        previousValue = item.DistrictThaiShort;
        return {
          value: item.DistrictThaiShort,
          label: item.DistrictThaiShort,
        };
      });

      setDistrictThai(mappedJson.filter(Boolean).map((item) => item));
    }
  }, [province]);

  useEffect(() => {
    if (district) {
      const dup = thj.map(({ TambonID, ...rest }) => rest);
      const t = dup.filter((row) => row.ProvinceThai === province);
      const ts = dup.filter((row) => row.DistrictThaiShort === district);

      let previousValue = null;
      const mappedJson = ts.map((item) => {
        if (item.TambonThaiShort === previousValue) {
          return null;
        }
        previousValue = item.TambonThaiShort;
        return {
          value: item.TambonThaiShort,
          label: item.TambonThaiShort,
        };
      });
      console.log(ts);

      setTambonThai(mappedJson.filter(Boolean).map((item) => item));
    }
  }, [district]);

  useEffect(() => {
    if (tambons) {
      const dup = thj.map(({ TambonID, ...rest }) => rest);
      const t = dup.filter((row) => row.TambonThaiShort === tambons);

      let previousValue = null;
      const mappedJson = t.map((item) => {
        if (item.PostCodeMain === previousValue) {
          return null;
        }
        previousValue = item.PostCodeMain;
        return {
          value: item.PostCodeMain,
          label: item.PostCodeMain,
        };
      });
      console.log(t);
      setzipcodes(mappedJson.filter(Boolean).map((item) => item));
    }
  }, [tambons]);

  const thaiprovince = () => {
    let previousValue = null;
    const mappedJson = thj.map((item) => {
      if (item.ProvinceThai === previousValue) {
        return null;
      }
      previousValue = item.ProvinceThai;
      return {
        value: item.ProvinceThai,
        label: item.ProvinceThai,
      };
    });

    setProvincethai(mappedJson.filter(Boolean).map((item) => item));
  };
  const provinceinput = (e) => {
    form.setFieldsValue({ district: "", cust_sub_district: "", Postcode: "" });
    console.log(e);
    setProvince(e);
    setformValue({
      ...formValue,
      city: e,
    });
  };

  const Tambon = (e) => {
    form.setFieldsValue({ Postcode: "" });
    console.log(e);
    setTambons(e);
    setformValue({
      ...formValue,
      cust_sub_district: e,
    });
  };

  const districts = (e) => {
    form.setFieldsValue({ cust_sub_district: "", Postcode: "" });
    console.log(e);
    setdistricts(e);
    setformValue({
      ...formValue,
      district: e,
    });
  };

  const postcodedata = (e) => {
    // form.setFieldValue({district: ""});

    setformValue({
      ...formValue,
      Postcode: e,
    });
  };

  return (
    <GuestLayout title={"ลงทะเบียนรับประกันสินค้า"}>
      <div className="textinput">
        <div className="subtextinput">
          <div className="title">
            <h2 hidden={disableinput}>
              ลงทะเบียนรับประกันสินค้า<br></br>Warranty Registration
            </h2>
            <h2 hidden={disablebutton}>
              ตรวจสอบข้อมูล<br></br>Review the Information
            </h2>
          </div>
          <Form layout="vertical" className="Form" form={form}>
            <Form.Item
              label={
                <span>
                  <span style={{ color: "red" }}>*</span>{" "}
                  <span style={{ color: "black" }}>คำนำหน้าชื่อ (Prefix)</span>
                </span>
              }
            >
              <Select
                value={formValue.prefix}
                disabled={disableinput}
                name="prefix"
                onChange={datainputselect}
              >
                <Select.Option value="นาย">นาย (Mr.)</Select.Option>
                <Select.Option value="นางสาว">นางสาว (Ms.)</Select.Option>
                <Select.Option value="นาง">นาง (Mrs.)</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item
              rules={[{ required: true, message: "กรุณากรอกชื่อ" }]}
              label="ชื่อจริง (First Name)"
              name="firstname"
            >
              <Input
                placeholder="ชื่อจริง"
                value={formValue.firstname}
                disabled={disableinput}
                onChange={datainputChange}
                name="firstname"
                required
              />
            </Form.Item>

            <Form.Item
              rules={[{ required: true, message: "กรุณากรอกนามสกุล" }]}
              label="นามสกุล (Last Name)"
              name="lastname"
            >
              <Input
                placeholder="นามสกุล"
                disabled={disableinput}
                value={formValue.lastname}
                onChange={datainputChange}
                name="lastname"
                required
              />
            </Form.Item>

            <Form.Item
              rules={[{ required: true, message: "กรุณากรอกที่อยู่" }]}
              label="ที่อยู่ (Address)"
              name="address"
            >
              <Input
                placeholder="ที่อยู่"
                disabled={disableinput}
                value={formValue.address}
                onChange={datainputChange}
                name="address"
              />
            </Form.Item>

            <Form.Item
              rules={[{ required: true, message: "กรุณากรอกจังหวัด" }]}
              label="จังหวัด (Province)"
              name="city"
            >
              <Select
                disabled={disableinput}
                placeholder="จังหวัด"
                showSearch
                options={provincethai}
                onChange={provinceinput}
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? "").includes(
                    input.toLowerCase()
                  ) ||
                  (option?.value?.toLowerCase() ?? "").includes(
                    input.toLowerCase()
                  )
                }
              />
            </Form.Item>

            <Form.Item
              rules={[{ required: true, message: "กรุณากรอกอำเภอ" }]}
              label="อำเภอ/เขต (District)"
              name="district"
            >
              {/* <Input placeholder="อำเภอ" disabled={disableinput} value={formValue.district} onChange={datainputChange} name="district" /> */}
              <Select
                disabled={disableinput}
                placeholder="อำเภอ"
                showSearch
                options={DistrictThai}
                onChange={districts}
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? "").includes(
                    input.toLowerCase()
                  ) ||
                  (option?.value?.toLowerCase() ?? "").includes(
                    input.toLowerCase()
                  )
                }
              />
            </Form.Item>
            <Form.Item
              rules={[{ required: true, message: "กรุณากรอกตำบล/แขวง" }]}
              label="แขวง / ตำบล (Sub-District)"
              name="cust_sub_district"
            >
              <Select
                disabled={disableinput}
                placeholder="ตำบล/แขวง"
                showSearch
                options={TambonThai}
                onChange={Tambon}
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? "").includes(
                    input.toLowerCase()
                  ) ||
                  (option?.value?.toLowerCase() ?? "").includes(
                    input.toLowerCase()
                  )
                }
              />
            </Form.Item>
            <Form.Item
              rules={[{ required: true, message: "กรุณากรอกรหัสไปรษณีย์" }]}
              label="รหัสไปรษณีย์ (Postal Code)"
              name="Postcode"
            >
              <Select
                disabled={disableinput}
                placeholder="รหัสไปรษณีย์"
                showSearch
                options={zipcodes}
                onChange={postcodedata}
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? "").includes(
                    input.toLowerCase()
                  ) ||
                  (option?.value?.toLowerCase() ?? "").includes(
                    input.toLowerCase()
                  )
                }
              />
            </Form.Item>

            <Form.Item
              rules={[
                {
                  required: true,
                  message: "กรุณากรอก E-mail",
                },
                {
                  pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: "กรุณากรอก E-mail ให้ถูกต้อง",
                },
              ]}
              label="Email"
              name="cust_email"
            >
              <Input
                placeholder="Email"
                disabled={disableinput}
                value={formValue.cust_email}
                onChange={datainputChange}
                name="cust_email"
              />
            </Form.Item>

            {/* <Form.Item rules={[{ required: true, message: 'กรุณากรอก E-mail' }]} label="Email" name="cust_email">
              <Input placeholder="Email" disabled={disableinput} value={formValue.cust_email} onChange={datainputChange} name="cust_email" />
            </Form.Item> */}

            <Form.Item>
              <Checkbox
                checked={pdpa}
                onChange={(e) => setpdpa(e.target.checked)}
              >
                ยินยอมให้เก็บข้อมูลของท่านเพื่อใช้ตามวัตถุประสงค์ในการให้บริการของเรา
                ภายใต้{" "}
                <a
                  href="https://www.bewellofficial.com/term-and-conditions/"
                  target="_blank"
                >
                  ข้อตกลงและเงื่อนไข
                </a>{" "}
                และ{" "}
                <a
                  href="https://www.bewellofficial.com/privacy-policy/"
                  target="_blank"
                >
                  นโยบายความเป็นส่วนตัว
                </a>
              </Checkbox>
              <Checkbox
                checked={email}
                onChange={(e) => setemailcheck(e.target.checked)}
              >
                ยินดีสมัครรับข่าวสารและโปรโมชันพิเศษจาก Bewell
              </Checkbox>
            </Form.Item>

            {!disableinput && (
              <Form.Item>
                <GreenButton block type="submit" onClick={firstsubmitfn}>
                  บันทึกข้อมูล
                </GreenButton>
              </Form.Item>
            )}

            {!disablebutton && (
              <Form.Item>
                <Row>
                  <Col span={12}>
                    <CancelButton onClick={disables}>ย้อนกลับ</CancelButton>
                  </Col>
                  <Col span={12}>
                    <GreenButton onClick={handleSubmit}>
                      บันทึกข้อมูล
                    </GreenButton>
                  </Col>
                </Row>
              </Form.Item>
            )}
          </Form>
        </div>
      </div>

      {/* </Box> */}
    </GuestLayout>
  );
}
